import type { BoxProps } from '@hover/blueprint';
import { Body, Box, Center, Motion, motion, useTheme } from '@hover/blueprint';
import React from 'react';

const MotionBox = motion(Box);

interface SwitchProps extends BoxProps {
  handleClick: () => void;
  offText: string;
  onText: string;
  isOn: boolean;
}

const Switch = ({
  handleClick,
  offText,
  onText,
  isOn,
  ...rest
}: SwitchProps) => {
  const { zIndices } = useTheme();
  return (
    <Box
      backgroundColor="darkAlpha.700"
      borderRadius="round"
      cursor="pointer"
      height={400}
      justifyContent="space-around"
      onClick={handleClick}
      padding={100}
      position="relative"
      width="154px"
      {...rest}
    >
      <Motion.Firm>
        <MotionBox
          animate={isOn ? 'on' : 'off'}
          backgroundColor="neutral.0"
          borderRadius="round"
          height={350}
          initial="after"
          position="absolute"
          variants={{
            off: {
              left: 4,
            },
            on: {
              right: 4,
            },
          }}
          width="48%"
          zIndex={zIndices.overlay - 1}
        />
        <Center width="50%">
          <Body
            isBold
            textColor={isOn ? 'neutral.0' : 'neutral.900'}
            zIndex={zIndices.overlay}
          >
            {offText}
          </Body>
        </Center>

        <Center width="50%">
          <Body
            isBold
            textColor={isOn ? 'neutral.900' : 'neutral.0'}
            zIndex={zIndices.overlay}
          >
            {onText}
          </Body>
        </Center>
      </Motion.Firm>
    </Box>
  );
};

export { Switch };
